/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/arrow-up-down
 */
import { default as DefaultIcon } from '~icons/lucide/arrow-up-down';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const ArrowUpDownIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
